<div class="login-container">
  @if (user()) {
    <button type="button" class="user-button dropdown-button" (click)="onDropdownClick($event)">
      <ng-container *ngIf="user().avatar; else defaultAvatar">
        <img
          src="{{ user().avatar | img: { width: 30, height: 30 } }}"
          [alt]="user()?.name + ' avatar'"
          class="avatar"
        />
      </ng-container>
      <span *ngIf="!compacted" class="username hyperlink">{{ user().username }}</span>
    </button>
  } @else {
    <button type="button" class="login-btn dropdown-button" (click)="login()">
      <ng-container [ngTemplateOutlet]="defaultAvatar"></ng-container>
      <span
        *ngIf="!compacted"
        class="login-text hyperlink"
        [attr.translation]="'user-dropdown-community.logIn'"
        i18n="@@user-dropdown-community.logIn"
        >Log in</span
      >
    </button>
  }
</div>
<p-menu
  #userMenu
  [popup]="true"
  [styleClass]="'dropdown-menu'"
  [styleClass]="'ush-menu-dropdown'"
  [model]="userMenuItems"
></p-menu>

<ng-template #defaultAvatar>
  <div class="avatar">
    <fa-icon [icon]="userIcon"></fa-icon>
  </div>
</ng-template>
